import { Grid, CardContent, Typography,  Link } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useDevice } from 'components/DeviceContext.js';

const useStyles = makeStyles({
    root: {
        width: '100%',
        maxWidth: '290px',
        textAlign: 'center',
				transition: 'transform 0.3s ease-in-out', // Adiciona a transição
				'&:hover': {
					transform: 'scale(1.05)', // Aumenta o card em 5% no hover
				},
    },
    title: {
        fontSize: '26px',
        textTransform: 'uppercase',
        marginBottom: '20px'
    },

});

const cardsData = [
    { title: 'mapas', content: 'Acesse nossos 3 mapas: Crack, Assistência Social e Fronteiras.', color: '#C4DAFF', corLetra: '#6699cc', image: require('imagens/imgCards/Maps.png'), link: '/mapas' },
    { title: 'boas práticas', content: 'Conheças experiências exitosa na área de combate às drogas.', color: '#F0E9D7', corLetra: '#cc9900 ', image: require('imagens/imgCards/Trophy.png') , link: '/boas-praticas'},
    { title: 'cartilhas', content: 'Baixe aqui nossas cartilhas sobre drogas, assistência social e juventude.', color: '#D7E9D1', corLetra: '#669966', image: require('imagens/imgCards/Books.png') , link: '/cartilhas'},
    { title: 'estudos', content: 'Veja aqui as pesquisas e estudos produzidos pelo Observatório.', color: '#E5D8F2', corLetra: '#9966cc', image: require('imagens/imgCards/Studies.png') , link: '/biblioteca'},
];

const Cards = () => {
    const classes = useStyles();
      const { isMobile } = useDevice();

    return (
        <Grid container justifyContent="center">
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', padding: isMobile ? '' : '20px 0 30px' }}>
            {cardsData.map((card, index) => (
              <Grid item key={index} style={{ margin: isMobile ? '0 0 60px 0' : '10px', width: '300px', color: card.corLetra }}>
                <Link href={card.link} style={{ textDecoration: 'none' }}>
                  <Grid className={classes.root} style={{ backgroundColor: card.color, borderRadius: '20px', height: isMobile ? '100%' : '90%', margin: isMobile ? '' : '20px' }}>
                    <img src={card.image} className={classes.cardImage} alt="" style={{ height: '150px', width: 'auto', borderRadius: '20px 20px 0 0', marginTop: '-40px' }} />
                    <CardContent className={classes.cardContent}>
                      <Typography className={classes.title} color="textSecondary" gutterBottom  style={{color: card.corLetra }}>
                        {card.title}
                      </Typography>
                      <Typography variant="body2" component="p" style={{color: card.corLetra, fontSize: '20px' }}>
                        {card.content}
                      </Typography>
                    </CardContent>
                  </Grid>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Grid>
      );
    }

export default Cards;
